import ProposalCardDetail from './ProposalCardDetail';
export default ProposalCardDetail;
